import { useNavigate } from 'react-router';
import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ACCOUNT_WIDE_SCOPE, GLOBAL_PRECONDITION_SCOPE } from '@/services';
import { PreconditionsSection } from '@/modules/integrations/components/preconditions-section';

/** Account-wide preconditions; ACCOUNT_WIDE_SCOPE says which actions they're checked for. */
export default function GlobalPreconditionsPage() {
	const navigate = useNavigate();

	return (
		<div className='flex h-full flex-col'>
			<div className='sticky top-0 z-10 flex shrink-0 items-center gap-2 border-b border-gray-500 bg-white px-4 py-3'>
				<Button
					variant='ghost'
					size='icon'
					className='size-7 rounded-full shrink-0'
					onClick={() => navigate('/settings/integrations')}
				>
					<ChevronLeft size={16} />
				</Button>
				<div className='flex min-w-0 flex-col'>
					<h1 className='text-base font-semibold'>Account-wide preconditions</h1>
					<p className='text-[13px] text-muted-foreground'>
						{ACCOUNT_WIDE_SCOPE} If either fails, the action goes to human approval.
					</p>
				</div>
			</div>
			<div className='relative flex flex-1 min-h-0 flex-col p-6 overflow-auto'>
				<PreconditionsSection provider={GLOBAL_PRECONDITION_SCOPE} tool={GLOBAL_PRECONDITION_SCOPE} />
			</div>
		</div>
	);
}
